import React from 'react';
import classes from "./TopBar.module.scss";
import HLIconButton from "../../../shared/components/icon-button/HLIconButton";
import {LogoutIcon} from "../../../shared/styles/icons/LogoutIcon";
import {useAppSelector} from "../../../shared/hooks/useAppSelector";
import {logoutRequest} from "../../../redux/slices/authSlice";
import {useAppDispatch} from "../../../shared/hooks/useAppDispatch";
import {useNavigate} from "react-router-dom";
import HLButton from "../../../shared/components/button/HLButton";

const TopBar = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const {currentTeacher} = useAppSelector(state => state.auth);

  const handleLogout = () => {
    dispatch(logoutRequest());
    navigate('/login');
  };

  return (
      <div className={classes.topBar}>
        <h2 className={classes.appName}>Hola School</h2>

        <div className={classes.userSection}>
          {currentTeacher && <>
            <span className={classes.userName}>{`${currentTeacher.firstName} ${currentTeacher.lastName}`}</span>
            <HLButton
                icon={<LogoutIcon/>}
                onClick={handleLogout}
            >Выйти</HLButton>
          </>
          }
        </div>
      </div>
  );
};

export default TopBar;